<template lang="html">
  <section class="take-place column">
			<div class="take-place from-start column">
			  <div class="heading-sub-client-container">
						<div class="heading-sub-client row start">
							<router-link :to="{name: 'Client', params: { clientId: clientId }}" class="btn-icon">
								<span class="icon-arrow-back"></span>
							</router-link>
							<div class="label">Détails de la situation de <span v-if="client">{{ client.firstname }} {{ client.lastname }}</span>
							</div>
						</div>
					</div>
			<synthesis :investment-stats="investmentStats" v-if="investmentStats" />
			</div>
  </section>
</template>

<script>
import Synthesis from '@/common/components/Investments/Synthesis.vue'

export default {
	name: 'InvestmentsClient',
	components: { Synthesis },

	data () {
		return {
			investmentStats: null
		}
	},
	computed: {
		clientId () {
			return this.$route.params.clientId
		},
		// Le client peut être absent du store (accès direct par URL ou rechargement de la page)
		client () {
			return this.$store.getters.getClient(this.clientId)
		}
	},
	mounted () {
		if (!this.client) {
			this.$store.dispatch('getClient', this.clientId)
		}

		this.$store.dispatch('getClientInvestmentStats', this.clientId)
				.then((investmentStats) => {
					this.investmentStats = investmentStats
				})
	}
}
</script>



// WEBPACK FOOTER //
// Investments.vue?339d332d